import React from "react";

const Title = () => {
  return (
    <div className="app__counter-container" style={{ padding: "20px" }}>
      <p className="p-text-sm">Counter App (Featuring Redux)</p>
    </div>
  );
};

export default Title;
